import React from 'react';
import { formatPrice } from '../../utils/format-number';

import { formatPremiereDate } from '../../utils/premiere';
import { translate } from '../../utils/wp.js';

export const PackageInfoPrice = ({
    packagePrice,
    ticketPrice,
    isPackage,
    isSoldOut,
    isCanceled,
    isPremiereLocked,
    premiereDate,
}) => {
    if (isPremiereLocked) {
        let title = isPackage
            ? translate('hotel_package_premieres')
            : translate('tickets_premieres');
        return (
            <div>
                {title}
                {' '}
                <span>{formatPremiereDate(
                    premiereDate,
                    'd MMMM \'kl.\' HH:mm',
                )}</span>
            </div>
        );
    }

    let text = translate('hotel_package_from');
    let price = packagePrice;
    if (!isPackage) {
        text = translate('tickets_from');
        price = ticketPrice;
    }

    if (isSoldOut) {
        return (
            <div>
                <span className="text-red">{translate('sold_out')}!</span>
            </div>
        );
    }

    if (isCanceled) {
        return (
            <div>
                <span className="text-red">{translate('cancelled')}</span>
            </div>
        );
    }

    return (
        <div>
            {text}&nbsp;
            <span className="text-black">{formatPrice(price)} SEK</span>
        </div>
    );
};
